export default __webpack_public_path__ + "static/media/allergy-menu.2d721301.png";